var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#54BD95",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.03467 5C8 5.38508 8 5.86903 8 6.48122V13.5188C8 14.131 8 14.6149 8.03467 15H7.33333C5.76198 15 4.97631 15 4.48816 14.5118C4 14.0237 4 13.238 4 11.6667V8.33333C4 6.76199 4 5.97631 4.48816 5.48816C4.97631 5 5.76198 5 7.33333 5H8.03467Z",
    fill: "#54BD95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4715 3.60596C8 4.02395 8 4.78856 8 6.31777V13.6826C8 15.2118 8 15.9764 8.4715 16.3944C8.943 16.8124 9.66369 16.6867 11.1051 16.4353L12.6576 16.1645C14.2539 15.886 15.0521 15.7468 15.526 15.1613C16 14.5758 16 13.729 16 12.0354V7.9649C16 6.27131 16 5.42451 15.526 4.839C15.0521 4.25349 14.2539 4.11428 12.6576 3.83585L11.1051 3.56507C9.66369 3.31367 8.943 3.18797 8.4715 3.60596ZM10.5 9.3025C10.5 9.01352 10.2761 8.77925 10 8.77925C9.72386 8.77925 9.5 9.01352 9.5 9.3025V10.6978C9.5 10.9868 9.72386 11.2211 10 11.2211C10.2761 11.2211 10.5 10.9868 10.5 10.6978V9.3025Z",
    fill: "#54BD95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.1170929d176acff2371c7db5f88ac00e.svg";
export { ForwardRef as ReactComponent };